/**
 * @fileOverview Javascript/CSS injection.
 * @author Selectra Front End Team
 * @version 1.0.0
 */


/**
 * @function injectSource
 * @description Browser agnostic solution to inject a script/stylesheet in the
 *     DOM, optionally executing a function once it has finished loading.
 *     *** IMPORTANT
 *     *** Keep this function IE11 compatible.
 *     *** It's used to load the polyfills!
 * @arg {String} source - URL for the src we want to inject.
 *     Accepts a js/css file path.
 * @arg {Function} [callback] - The name of the function we want to call back
 *     once the resource has finished loading.
 */
export default function injectSource( srcUrl, callback ) {

  const

    containers = {
      css:
          document.getElementsByTagName( 'head' )[ 0 ] ||
            document.documentElement,
      js:
        document
          .getElementsByTagName( 'script' )[ 0 ].parentElement,
    },


    injection = ( function genInjection( url ) {
      let
        newTag = null,
        tagType = null;
      if ( url.match( /^.*\.js$/ )) {
        tagType = 'js';
        newTag = document.createElement( 'script' );
        newTag.src = url;
        newTag.type = 'text/javascript';
      } else if ( url.match( /^.*\.css$/ )) {
        tagType = 'css';
        newTag = document.createElement( 'link' );
        newTag.href = url;
        newTag.rel = 'stylesheet';
        newTag.type = 'text/css';

      } else {
        throw new TypeError( 'Unsupported source type.' );
      }
      return {
        type: tagType,
        tag: newTag,
      };
    }( srcUrl ));

  if ( callback ) {
    let done = false;
    injection.tag.onload = injection.tag.onreadystatechange =
      function executeCallback() {
        const doExecute =
          !done && (
            !this.readyState ||
            this.readyState === 'loaded' ||
            this.readyState === 'complete'
          );
        if ( doExecute ) {
          this.onload = this.onreadystatechange = null;
          callback();
          if ( injection.type === 'js' ) {
            this.parentElement.removeChild( this );
          }
          done = true;
        }
      };
  }

  containers[ injection.type ].appendChild( injection.tag );

}


/**container
 * @function injectCollection
 * @description Inject a collection of scripts and/or stylesheets in the DOM,
 *     optionally executing a function once them all have finished loading.
 * @arg {Array} sources - URLs for the sources we want to inject.
 *     Accepts js/css file paths.
 * @arg {Function} [callback] - The name of the function we want to call back
 *     once the last resource has finished loaded.
 */
export function injectCollection( sources, callback ) {
  if ( Array.isArray( sources )) {

    let currentSource = 0;
    const totalSources = sources.length - 1;

    ( function injectSources() {
      let currentCallback = null;
      if ( currentSource !== totalSources ) {
        currentCallback = injectSources;
      } else if ( callback ) {
        currentCallback = callback;
      }
      injectSource( sources[ currentSource++ ], currentCallback );
    }());

  } else {
    throw new TypeError( '\'sources\' argument must be an array' );
  }
}

